import React from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const DarkBreadcrumbs = ({ items }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" sx={{ color: "#666" }} />}
      aria-label="breadcrumb"
      sx={{ mb: 1 }}
    >
      {items.map((item, index) =>
        item.path ? (
          <Link
            key={index}
            to={item.path}
            style={{
              textDecoration: "none",
              color: "#ccc",
              fontSize: "14px",
            }}
            onMouseOver={(e) => (e.target.style.color = "#FFC001")}
            onMouseOut={(e) => (e.target.style.color = "#ccc")}
          >
            {item.label}
          </Link>
        ) : (
          <Typography
            key={index}
            sx={{ color: "#FFC001", fontSize: "14px" }}
          >
            {item.label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  );
};

export default DarkBreadcrumbs;
